import { render, staticRenderFns } from "./orderTabThree.vue?vue&type=template&id=7747bd18"
import script from "./orderTabThree.vue?vue&type=script&lang=js"
export * from "./orderTabThree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports